<template>
  <div class="instagram">
    <div class="cta">
      <article>
        <h4>#liebdinge</h4>
        <i class="heart"></i>
        <h2>Teile dein Liebding auf Instagram</h2>
      </article>
    </div>
    <div class="instahead">Dinge und Geschichten von anderen</div>
    <items class="instafeed grid wrapper" :items="items"></items>
  </div>
</template>


<script>
import Items from '@/components/Items'
import Masonry from 'masonry-layout'
import imagesLoaded from 'imagesloaded'
import Instafeed from 'instafeed.js'

export default {
  components: {
    'items': Items
  },
  data () {
    return {
      items: []
    }
  },
  mounted () {
    let self = this
    // To get tagged photos you need the `public_content` scope.
    // https://github.com/stevenschobert/instafeed.js/issues/408#issuecomment-256345776
    // http://instagramwordpress.rafsegat.com/docs/get-access-token/
    let feed = new Instafeed({
      get: 'tagged',
      tagName: 'liebdinge',
      accessToken: '227678620.ba4c844.bb9bd1233783406bbc8be071c19515af',
      resolution: 'standard_resolution',
      mock: true,
      limit: 100,
      success (images) {
        images.data.forEach((image) => {
          let img = {
            profile: image.user.profile_picture,
            name: image.id,
            description: image.user.username,
            image: image.images.standard_resolution.url,
            story: image.caption.text,
            link: image.link,
            width: 6,
            height: 6
          }
          self.items.push(img)
        })
      },
      after () {
        let instafeed = new Masonry('.instafeed', {
          itemSelector: '.item',
          columnWidth: 28,
          gutter: 40
        })
        imagesLoaded('.instafeed', () => {
          instafeed.reloadItems()
          instafeed.layout()
        })
      }
    })
    feed.run()
  }
}
</script>

<style lang="scss">
.instagram {
  position: relative;

  &:before {
    content: '';
    height: 30px;
    width: 100%;
    position: absolute;
    background: black;
    left: 0;
    top: 220px;
    margin-top: -15px;
  }
}

.instahead {
  margin-bottom: 42px;
  text-align: center;
  font-weight: 700;
  font-size: 35px;
  text-transform: uppercase;
  letter-spacing: 6.25px;
  line-height: 1.25;
}

.cta {
  margin: 0 auto 290px;
  width: 775px;
  height: 525px;
  background-color: #f7f7f7;
  position: relative;



  article {
    text-align: center;

    h2 {
      font-weight: 700;
      font-size: 40px;
      margin: 50px 70px;
      text-transform: uppercase;
      letter-spacing: 6.25px;
      line-height: 1.25;
    }

    h4{
      font-family: 'CorporateS', sans-serif;
      font-style: italic;
      font-weight: 400;
      font-size: 50px;
      transform: rotate(-15deg) translateX(-10px);
      display: inline-block;

      &:after {
        height: 3px;
        width: 100%;
        background: black;
        content: '';
        position: absolute;
        bottom: -6px;
        left: 0;
        margin-bottom: 5px;
      }
    }
  }

  .heart {
    width: 44px;
    height: 40px;
    display: block;
    margin: 0 auto;
    background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkViZW5lXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgNDYgNDIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDQ2IDQyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHN0eWxlIHR5cGU9InRleHQvY3NzIj4uc3Qwe2ZpbGw6I0RDMEQxNTt9PC9zdHlsZT48cGF0aCBjbGFzcz0ic3QwIiBkPSJNMTMuOSwxYy0zLjMsMC02LjYsMS4zLTkuMSwzLjljLTUsNS4yLTUsMTMuNywwLDE4LjlsMTcuMiwxNi43YzAuMywwLjMsMC43LDAuNSwxLjEsMC41YzAuNCwwLDAuOC0wLjEsMS4xLTAuNWwxNy4yLTE2LjdjMi41LTIuNiwzLjgtNiwzLjgtOS40YzAtMy40LTEuMy02LjktMy44LTkuNGMtMi4yLTIuMy01LjEtMy40LTguMS0zLjRjLTMuNiwwLTcuMywxLjYtMTAsNC4zTDIzLjEsNmMwLDAtMC4xLDAtMC4xLTAuMUMyMC4zLDMuNCwxNy4xLDEsMTMuOSwxTDEzLjksMXoiLz48L3N2Zz4=);
  }
}

</style>



// WEBPACK FOOTER //
// Instagram.vue?9be1cc00